import { Checkbox } from '../../../ui/input/checkbox';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Image } from '../../../ui/image/image';
import './retouch.use-image.scss';
import iconAdjust2Screen from '../../../../assets/img/icon/adjust2screen.svg';
import { useAppSelector } from '../../../../app/hooks';
import * as lodash from 'lodash';
import { UiManager } from '../../../../layout-editor/manager/ui/ui.manager';
import { EditableImage } from '../../../../layout-editor/manager/image-edit/editable-image';
import { EditableImageManager } from '../../../../layout-editor/manager/editable-image/editable-image.manager';
import { DynamicTooltip } from '../../../ui/tooltip/dynamic-tooltip';
import { useDispatch } from 'react-redux';
import { apiActions } from '../../../../slices/api-slice';
import { ApiRetouchGet, RetouchGetResponse, SimpleRetouchInfo } from '../../../../api/back/retouch/api-retouch';
import { ResponseBase } from '../../../../api/response-base';
import { ApiImagesGetOne } from '../../../../api/front/images/api-images';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../routes/routing-path';
import { ImageCheckItem, retouchActions, ShowMenuType } from '../../../../slices/retouch-slice';
import { cloneDeep } from 'lodash';
import { XmlStructureModel } from '../../../../xml/model/xml-structure-model';
import { InitRetouchCheck, ToneCorrectionImageData } from '../print-tone-correction';
import { OrderSelectImageData } from '../../../../xml/model/order/xml-order-select-model';
import { LoadingPopup } from '../../../ui/loading/loading-popup';
import { LayoutXmlUtile } from '../../../../layout-editor/model/layout.xml.utile';
import { DateFormatter } from '../../../../utilities/date-formatter';
import { TrimEditableImage } from '../../../../trim-editor/manager/image-edit/trim.editable-image';
import { PrintDataStructure } from '../../../../models/sift/json/print-model';

const getFormatDate = (date: Date): string => {
  const fullDate = new Intl.DateTimeFormat('jp').format(date);
  const time = new Intl.DateTimeFormat('jp', { hour: '2-digit', minute: '2-digit' }).format(date);
  return fullDate + ' ' + time;
};

type OneProps = {
  // - 画像リスト -
  imageList: ToneCorrectionImageData[],
  // - 選択中画像のリストのindex -
  oneIndex: number,
  // - 画像のindexを取得するハンドラ -
  onGetIndex: (index: number) => void,
  // // - 一括変更するgarbage値 -
  // iniGarbage: boolean,
  // // - 一括変更するdirt値 -
  // iniDirt: boolean,
  // - 画像一覧からごみチェック操作したフラグ -
  isToOne: boolean,
  // - 画像一覧からごみチェック操作したフラグ更新ハンドラ -
  changeToOneFlag: () => void,
  limitEle: HTMLElement | null,
  handlerCheckItem: (item: ToneCorrectionImageData) => void,
}
type ScaleBtnType = 'plus' | 'minus' | 'fit';
const One = (props: OneProps) => {
  const {
    imageList,
    oneIndex,
    onGetIndex,
    isToOne,
    changeToOneFlag,
    handlerCheckItem,
    limitEle,
  } = props;
  // - State -
  const initScale = 1;
  const [scale, setScale] = useState(initScale);
  const [index, setIndex] = useState(oneIndex);
  const [centerAspectRatio, setCenterAspectRatio] = useState(0);
  const [scaleBtnTooltipType, setScaleBtnTooltipType] = useState<ScaleBtnType | 'none'>('none');
  // - Ref -
  const thumbEle = useRef<HTMLDivElement>(null);
  const scaleBtnEle = useRef<React.RefObject<HTMLDivElement>[]>(new Array(3).fill(React.createRef()));

  const itemName = useMemo(() => {
    return imageList[index].editableImage?.name ?? '';
  }, [imageList, index]);

  const itemCreateDate = useMemo(() => {
    const date = imageList[index].editableImage?.exif.createDate ?? ''
    return date ? DateFormatter.date2str(date) : '';
  }, [imageList, index]);

  // - Callback -
  const handlerChangeScale = useCallback((v) => {
    if (v < 0.1 || v > 4) {
      return;
    }
    setScale(v);
  }, []);
  const handlerChangeImage = useCallback((v) => {
    if (v < 0) {
      setIndex(imageList.length - 1);
      onGetIndex(imageList.length - 1);
    } else if (v >= imageList.length) {
      setIndex(0);
      onGetIndex(0);
    } else {
      setIndex(v);
      onGetIndex(v);
    }
  }, [onGetIndex]);
  const handlerHoverScaleButton = useCallback((v: {
    mouseEnter: boolean,
    buttonType?: ScaleBtnType,
  }) => {
    setScaleBtnTooltipType(v.mouseEnter ? v.buttonType || 'none' : 'none');
  }, []);

  const handlerChangeChecked = useCallback((item: SimpleRetouchInfo, checked: boolean) => {
  }, []);

  // - Effect -
  useEffect(() => {
    setIndex(oneIndex);
    // if (imageList.length) {
      // setFormatDate(getFormatDate(imageList[index].exif.createDate));
    // }
  }, [oneIndex]);
  useEffect(() => {
    if (isToOne) {
      changeToOneFlag();
    }
  }, [isToOne]);
  useEffect(() => {
    const width = thumbEle.current?.getBoundingClientRect().width || 0;
    const height = thumbEle.current?.getBoundingClientRect().height || 0;
    setCenterAspectRatio(width / height);
  }, [thumbEle]);
  useEffect(() => {
    const reCalcAspect = () => {
      const width = thumbEle.current?.getBoundingClientRect().width || 0;
      const height = thumbEle.current?.getBoundingClientRect().height || 0;
      setCenterAspectRatio(width / height);
    };
    window.addEventListener('resize', reCalcAspect);
    return () => window.removeEventListener('resize', reCalcAspect);
  }, []);
  // -- 選択画像が変わった時拡大率を戻す --
  useEffect(() => {
    setScale(initScale);
  }, [index]);

  return (
    <div className="one_conts">
      {/* ズーム系ツール */}
      <div className="zoom_menu">
        <div
          className="zoom_menu__in rect_icon plus_icon"
          onClick={() => handlerChangeScale(scale + 0.1)}
          onMouseEnter={() => handlerHoverScaleButton({ mouseEnter: true, buttonType: 'plus' })}
          onMouseLeave={() => handlerHoverScaleButton({ mouseEnter: false })}
          ref={scaleBtnEle.current[0]}
        >
          {scaleBtnTooltipType === 'plus'
            ? <DynamicTooltip
              messages={['拡大']}
              relativeEle={scaleBtnEle.current[0].current}
              onClick={(e) => e.stopPropagation()}
            />
            : <></>}
        </div>
        <div
          className="zoom_menu__out rect_icon minus_icon"
          onClick={() => handlerChangeScale(scale - 0.1)}
          onMouseEnter={() => handlerHoverScaleButton({ mouseEnter: true, buttonType: 'minus' })}
          onMouseLeave={() => handlerHoverScaleButton({ mouseEnter: false })}
          ref={scaleBtnEle.current[1]}
        >
          {scaleBtnTooltipType === 'minus'
            ? <DynamicTooltip
              messages={['縮小']}
              relativeEle={scaleBtnEle.current[1].current}
              onClick={(e) => e.stopPropagation()}
            />
            : <></>}
        </div>
        <div
          className="zoom_menu__screen rect_icon"
          onClick={() => handlerChangeScale(initScale)}
          onMouseEnter={() => handlerHoverScaleButton({ mouseEnter: true, buttonType: 'fit' })}
          onMouseLeave={() => handlerHoverScaleButton({ mouseEnter: false })}
          ref={scaleBtnEle.current[2]}
        >
          <img
            src={iconAdjust2Screen}
            alt=""
          />
          {scaleBtnTooltipType === 'fit'
            ? <DynamicTooltip
              messages={['画面に合わせる']}
              relativeEle={scaleBtnEle.current[2].current}
              onClick={(e) => e.stopPropagation()}
              limitEle={limitEle}
            />
            : <></>}
        </div>
      </div>
      {/* 次の画像 */}
      <div
        className="rect_icon next_btn triangle_icon"
        onClick={() => handlerChangeImage(index + 1)}
      />
      {/* 前の画像 */}
      <div
        className="rect_icon pre_btn triangle_icon triangle_icon_left"
        onClick={() => handlerChangeImage(index - 1)}
      />

      <div className="one_conts__body">
        <div className="one_conts__body__left">
          <div className="checks">
            <Checkbox
              label="色補正する"
              checked={!!imageList[index]?.toneCorrection?.value}
              onClick={() => {
                const item = imageList[index];
                if (item) {
                  handlerCheckItem(item);
                }
              }}
            />
          </div>
        </div>
        {imageList.length ?
          <div className="one_conts__body__center">
            <div
              className="one_conts__thumb"
              ref={thumbEle}
            >
              <Image
                key={`retouch-image_${imageList[index].id}`}
                src={imageList[index].editableImage!.thumbnailBase64}
                alt="画像エリア"
                // scale={scale}
                containerAspectRatio={centerAspectRatio || undefined}
                retouchScale={scale}
                style={{
                  transformOrigin: scale > 1 ? 'top left' : undefined,
                  // transform: scale ? `scale(${scale})` : undefined,
                }}
              />
            </div>
            <div className="one_conts__thumb__name">
              <span>{itemName}</span>
              <span>{itemCreateDate}</span>
              {/*<span>{formatDate}</span>*/}
            </div>
          </div>
          : <></>}
        <div className="one_conts__body__right" />
      </div>
    </div>
  );
};

type ListItemProps = {
  data: ToneCorrectionImageData,
  // - 画像リストのindex -
  listIndex?: number,
  // - 画像のindexを取得するハンドラ -
  onGetIndex?: (index: number) => void,
  // - refを取得するハンドラ -
  onGetRef?: (ref: HTMLDivElement) => void,
  // - 選択されているかフラグ -
  isSelect?: boolean,
  // - 画像一覧からごみチェック操作したフラグ更新ハンドラ -
  changeToOneFlag?: () => void,
  handlerCheckItem: (item: ToneCorrectionImageData) => void,
  // - レタッチメニューと商品情報表示の状態 -
  showMenuType: ShowMenuType,
  isOne?: boolean;
  structure: PrintDataStructure | undefined,
};
const ListItem = (props: ListItemProps) => {
  const {
    data,
    listIndex,
    onGetIndex,
    handlerCheckItem,
    onGetRef,
    isSelect,
    structure,
    showMenuType,
    isOne,
  } = props;
  const dispatch = useDispatch();
  // - Ref -
  const itemRef = useRef<HTMLDivElement>(null);
  const imageCheckList = useAppSelector((v) => v.retouch.imageCheckItemList);
  // - State -
  const [isHover, setIsHover] = useState(false);

  const goodsName = useMemo(() => {
    if (!structure) {
      return '';
    }
    const list = structure.getItemList();
    const goodName = list.find((v) => v.images.find((img) => img.id === data.id))?.productData?.productDetailParent.productShortName ?? '';
    return goodName;
  }, [
    data,
    structure,
  ]);

  useEffect(() => {
    if (onGetRef && itemRef.current) {
      onGetRef(itemRef.current);
    }
  }, []);

  return (
    <div
      className={`retouch_list_item${isSelect ? ' selected' : ''}${isOne ? ' one_list_item' : ''}`}
      ref={itemRef}
    >
      <div className="retouch_list_item__body__wrap">
        <div
          className="retouch_list_item__body"
          onClick={() => {
            onGetIndex?.(listIndex ? listIndex : 0);
          }}
        >
          <div className="retouch_list_item__body__inner">
            {/* 選択時タグ */}
            {/* {data?.toneCorrection?.value && !isOne ? ( */}
            {!isOne ? (
              <div className="retouch_list_item__selected_tag">
                <span>使用画像</span>
              </div>
            ) : (<></>)}

            {/* チェックボックスコンテンツ */}
            <div
              className="retouch_list_item__header"
              style={showMenuType === 'name' ? { height: 'initial' } : {}}
            >
              {!isOne &&
                <div className="checks">
                  <Checkbox
                    label="色補正する"
                    checked={!!data.toneCorrection?.value}
                    onClick={() => handlerCheckItem(data)}
                  />
                </div>}
              {/* 商品情報表示 */}
              {/*{showMenuType === 'name' ? (*/}
              {/*  <div className="goods_name">{goodsName}</div>*/}
              {/*) : (<></>)}*/}
            </div>


            {/* 画像 */}
            <div
              className="retouch_list_item__thumb"
              onClick={() => {
                // onGetIndex?.(listIndex ? listIndex : 0);
              }}
              onMouseOver={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <Image
                src={data?.editableImage?.thumbnailBase64}
                containerAspectRatio={1.19}
              />
            </div>

            {/* 画像ファイル名 */}
            <div className="retouch_list_item__name">
              <div>{data?.editableImage?.name}</div>
              {/*<div>{itemName}</div>*/}
            </div>

            {/* {isHover ? (
              <StaticTooltip
                messages={[
                  `サイズ：`,
                  `撮影日時：${formatDate}`,
                ]}
                pos={{x: '0', y: '0'}}
              />
            ) : (<></>)} */}

          </div>
        </div>
      </div>
    </div>
  );
};

type Props = {
  viewImages: ToneCorrectionImageData[],
  allCheck: boolean,
  isLoading: boolean,
  handlerChangeAllCheck: () => void,
  handlerCheckItem: (item: ToneCorrectionImageData) => void,
  structure?: PrintDataStructure,
}

export const RetouchUseImage = (props: Props) => {
  const {
    viewImages,
    allCheck,
    handlerChangeAllCheck,
    handlerCheckItem,
    structure,
    isLoading,
  } = props;
  const imageList = useMemo(() => {
    return viewImages.filter((v) => v.editableImage);
  }, [
    viewImages,
  ])
  const {
    displayType,
    sortType,
    showMenuType,
  } = useAppSelector((state) => ({
    displayType: state.storage.data.toneCorrectionMenu.bubbleType,
    sortType: state.storage.data.toneCorrectionMenu.sortType,
    showMenuType: state.storage.data.toneCorrectionMenu.showMenuType,
  }), lodash.isEqual);
  const dispatch = useDispatch();
  // - State -
  const bodyRef = useRef<HTMLDivElement>(null);
  // - State -
  // -- 1コマ時の画像一覧開閉状態 --
  const [oneListOpen, setOneListOpen] = useState(true);
  // -- 1コマ表示する画像index --
  const [oneIndex, setOneIndex] = useState(0);
  // -- 画像一覧のrefリスト --
  const [oneRefList, setOneRefList] = useState<HTMLDivElement[]>([]);
  // - 画像一覧からごみチェックしたフラグ -
  const [isToOne, setIsToOne] = useState(false);
  // - 6コマ表示の列数 -
  const [sixFrameRows, setSixFrameRows] = useState(2);

  // - Effect -
  // -- 画像一覧のref取得 --
  useEffect(() => {
    if (displayType !== 'one') return;
    const targetRef = oneRefList.find((ref) => ref.className.indexOf('selected') !== -1);
    if (targetRef) {
      targetRef.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
    }
  }, [oneRefList, oneIndex, sortType]);

  // -- 6コマ表示の列数後進 --
  useEffect(() => {
    const minRowCount = Math.floor(imageList.length / 3);
    setSixFrameRows(imageList.length % 3 === 0 ? minRowCount : minRowCount + 1);
  }, [imageList.length]);

  return (
    <div className="retouch_use_image">
      {imageList.length ?
        <>
          <div className="retouch_use_image__inner">
            <div className="retouch_use_image__inner__header">
              <div className="retouch_use_image__inner__header__left">
                <div>一括選択（すべて選択）</div>
                <div className="check_contents">
                  <Checkbox
                    label="色補正する"
                    checked={allCheck}
                    onClick={handlerChangeAllCheck}
                    stopPropagation
                  />
                </div>
              </div>
              <div className="retouch_use_image__inner__header__right">
                <div className="bordered_left_label_item">
                  <span>利用画像</span>
                  <div>{imageList.length}</div>
                </div>
              </div>
            </div>
            <div
              className={`retouch_use_image__inner__body ${displayType}`}
              style={displayType === 'six' ? {
                gridTemplateRows: `repeat(${sixFrameRows}, calc(50% - 1.75em))`,
              } : {}}
              ref={bodyRef}
            >
              {displayType === 'list' ? (
                imageList.map((v, i) => (
                  <ListItem
                    key={`use-image-item_${v.id}`}
                    data={v}
                    onGetIndex={() => {
                      setOneIndex(i);
                    }}
                    isSelect={i === oneIndex}
                    showMenuType={showMenuType}
                    structure={structure}
                    handlerCheckItem={handlerCheckItem}
                  />
                ))
              ) : (<></>)}
              {displayType === 'six' ? (
                imageList.map((v, i) => (
                  <ListItem
                    key={`use-image-item_${v.id}`}
                    data={v}
                    onGetIndex={() => {
                      setOneIndex(i);
                    }}
                    isSelect={i === oneIndex}
                    showMenuType={showMenuType}
                    structure={structure}
                    handlerCheckItem={handlerCheckItem}
                  />
                ))
              ) : (<></>)}
              {displayType === 'one' ? (
                <One
                  imageList={imageList}
                  oneIndex={oneIndex}
                  onGetIndex={(index) => setOneIndex(index)}
                  isToOne={isToOne}
                  handlerCheckItem={handlerCheckItem}
                  changeToOneFlag={() => setIsToOne(false)}
                  limitEle={bodyRef?.current}
                />
              ) : (<></>)}
            </div>
          </div>
          {displayType === 'one' ? (
            <div className={`retouch_use_image__inner one_list ${oneListOpen ? '' : 'closed'}`}>
              <div className="row_list__header">
                画像一覧
                <div
                  className={`rect_icon ${oneListOpen ? 'minus_icon' : 'plus_icon'}`}
                  onClick={() => setOneListOpen(!oneListOpen)}
                />
              </div>
              {oneListOpen ?
                (<div className="row_list__body">
                  {imageList.map((v, i) => (
                    <ListItem
                      key={`use-image-item_${v.id}`}
                      data={v}
                      listIndex={i}
                      structure={structure}
                      onGetIndex={(index) => setOneIndex(index)}
                      onGetRef={(ref) => setOneRefList(prev => {
                        if (!i) {
                          return [ref];
                        }
                        return [...prev, ref];
                      })}
                      isSelect={oneIndex === i}
                      handlerCheckItem={handlerCheckItem}
                      changeToOneFlag={() => setIsToOne(true)}
                      showMenuType={showMenuType}
                      isOne
                    />
                  ))}
                </div>) : (<></>)}
            </div>
          ) : (<></>)}
        </>
        : (!!(isLoading && !imageList.length) && <div className="retouch_use_image__none">色補正可能な画像がありません</div>)}
    </div>
  );
};
